export interface ICommonRes<T = any> {
    totalRows: number;
    items: T[];
}

export enum ESubscribeMode {
    CREATE = 'create',
    SWITCH = 'switch',
    RENEW = 'renew'
}

export interface IOkRes {
    message: 'ok';
}

export interface ICountryItem {
    code: string;
    name: string;

    /** 用于组件显示，与name的值相同 */
    text: string;
    image: string;
}
